import React, { Fragment, useEffect } from 'react'
import InputsGroup from './InputsGroup'
import CheckBox from './Checkbox'
import FileUpload from './FileUpload'
import Radio from './Radio'
import Select from './Select'
import TextArea from './TextArea'
import Listado from './Listado'
import TextInput from './TextInput'
import PriceRange from './PriceRange'
import Chips from './Chips'
import DatePicker from './DatePicker'
import ShowMessage from './ShowMessage'
import Link from './Link'
import Maps from './Maps'

export default function Input({
  type = `text`,
  hidden = false,
  didMount,
  disabled,
  didMountDispatcher,
  valueListener,
  loading = false,
  ...rest
}) {
  const props = {
    ...rest,
    loading,
    didMount,
    disabled,
    valueListener,
    didMountDispatcher,
    type,
    ...(type !== `group` && {
      onChange: valueListener(rest.id),
      onBlur: valueListener(rest.id),
    }),
    
  }
  function checkDimount() {
    if (!hidden && didMount && !loading) {
      didMountDispatcher({ fieldId: props.id, didMount })
    }
  }
  useEffect(checkDimount, [hidden, disabled])
  //SAARGO
  function renderInput() {
    switch (type.toLowerCase()) {
      case `radiogroup`:
        return <Radio {...props} />
      case `multiselect`:
        return <Select {...props} mode="multiple"  disableAutoFocus />
      case `select`:
        return <Select {...props}  disableAutoFocus />
      case `check`:
        return <CheckBox {...props} />
      case `month`:
      case `date`:
        return <DatePicker {...props} />
      case `price_range`:
        return <PriceRange {...props} />
      case `text`:
      case `number`:
      case `password`:
        return <TextInput {...props} />
      case `textarea`:
        return <TextArea {...props} />
      case `image`:
      case `file`:
        return <FileUpload {...props} />
      case `chips`:
        return <Chips {...props} />
      case `group`:
        return <InputsGroup {...props} />
      case `message`:
        return <ShowMessage {...props} />
      case `link`:
        return <Link {...props} />
      case `maps`:
        return <Maps {...props} />
      case `listado`:
        return <Listado {...props} />
      default:
        return null
    }
  }

  return <Fragment>{!hidden && renderInput()}</Fragment>
}
